import { ApiCallUploadMethodJson } from "../../../constant/base";

export const getAddressDetail = (body) => {
  return ApiCallUploadMethodJson("api/zipcode", "POST", body);
};
